import React from "react";
import Link from 'next/link'

import marketThumb from "assets/images/careers/market_thumb.png";
import smartchainThumb from "assets/images/careers/smartchain_thumb.png";

import styles from "./index.module.less";

const marketingJobs = [
  ["Content Writer_Copywriter JD", "content-writer"],
  ["Data Analyze JD", "data-analyze"],
  ["Digital Marketing JD", "digital-marketing"],
  ["Director of Marketing JD", "marketing-director"],
  ["Public Relations and Branding JD", "public-relations-branding"],
  ["SEO and SEM JD", "seo-sem"],
  ["User Growth and Retention", "user-growth-retention"],
];
const smartChainJobs = [
  ["Spikex SmartChain CEO", "smartchain-ceo"],
  ["Spikex SmartChain CMO", "smartchain-cmo"],
];

type DepartmentProps = { thumb: string; title: string };

const Department = ({ thumb, title }: DepartmentProps) => {
  return (
    <div className={styles.vacancyDepartment}>
      <div className={styles.cardContent}>
        <div className={styles.cardContentPic}>
          <img src={thumb} alt={title} />
        </div>
        <div className={styles.cardContentTitle}>{title}</div>
      </div>
    </div>
  );
};

type LinkCardProps = { title: string; href: string };

const LinkCard = ({ title, href }: LinkCardProps) => {
  return (
    <div className={styles.linkCard}>
      <div>
        <Link href={href}>
          <div className={styles.cardContent}>
            <h4>{title}</h4>
            <div className={styles.cardIcon}></div>
          </div>
        </Link>
      </div>
    </div>
  );
};

const Vacancies = () => {
  return (
    <div className={styles.careersVacancies}>
      <div className={styles.vacancyTitle}>Vacancies</div>
      <div className={styles.vacancyDetail}>
        <Department thumb={marketThumb} title={"Marketing Positions"} />
        <div className={styles.vacancyDepartmentDetails}>
          {marketingJobs.map((job) => (
            <LinkCard key={job[0]} title={job[0]} href={`/careers/marketing_${job[1]}`} />
          ))}
        </div>
      </div>
      <div className={styles.vacancyDetail}>
        <Department thumb={smartchainThumb} title={"SmartChain"} />
        <div className={styles.vacancyDepartmentDetails}>
          {smartChainJobs.map((job) => (
            <LinkCard key={job[0]} title={job[0]} href={`/careers/smartchain_${job[1]}`} />
          ))}
        </div>
      </div>
    </div>
  );
};

export default Vacancies;
